import { IconWrapper } from '../runtime';
export default IconWrapper('doc_upload_flat', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.5 2.64049C1.5 1.18246 2.68197 0.000488281 4.14 0.000488281L16.5665 0.000488758C17.2666 0.000488758 17.9381 0.278631 18.4332 0.773727L21.7268 4.06725C22.2219 4.56235 22.5 5.23384 22.5 5.93401V21.3605C22.5 22.8185 21.318 24.0005 19.86 24.0005H4.14C2.68197 24.0005 1.5 22.8185 1.5 21.3605V2.64049Z",
      "fill": "#1983FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M16.5 0C17.2371 0 17.944 0.292749 18.4654 0.813873L21.6846 4.03198C22.2067 4.55387 22.5 5.26181 22.5 6H18C17.1716 6 16.5 5.32843 16.5 4.5V0Z",
      "fill": "white",
      "fill-opacity": "0.3"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.9997 8.125L16.5144 12.6397L15.4537 13.7004L12.7497 10.9963V17.7812H11.2497V10.9963L8.54565 13.7004L7.48499 12.6397L11.9997 8.125Z",
      "fill": "white"
    }
  })]);
});